import type { Release } from '../releases.ts';

export default {
  version: '0.22.1',
  date: '2026-10-05',
  title: 'Sequence playback in Safari',
  summary: [
    'Fixed: sequence playback in Safari no longer stutters; picture and sound jumped about twice a second',
  ],
  features: [],
  fixes: [
    'Sequence playback in Safari no longer stutters: picture and sound jumped about twice a second because the preview kept re-seeking a clip that Safari is slow to start; it now gives the clip time to settle and aims ahead by Safari’s start delay',
  ],
} satisfies Release;
